module.exports = __webpack_public_path__ + "static/media/YasharthSingh.fb60cc1a.jpg";